module.exports = __webpack_public_path__ + "static/media/12.991a3e25.jpg";